import Card from "@material-ui/core/Card";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import MuiTableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { OrderDetailsListColumns } from "@saleor/config";
import { maybe, renderCollection } from "@saleor/misc";
import { isExpressDelivery } from "@saleor/motherOrders/utils/handlers";
import OrderLineStatus from "@saleor/storeOrders/components/StoreOrderDetailsList/components/OrderLineStatus";
import { storeOrderPath } from "@saleor/storeOrders/urls";
import { ListProps } from "@saleor/types";
import { DeliveryTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage } from "react-intl";

import {
  OrderDetails_order_subOrders,
  OrderDetails_order_voucher
} from "../../types/OrderDetails";
import OrderStatus from "../OrderStatus";
import PrepTimeLocation from "./components/PrepTimeLocation";
import ProductSku from "./components/ProductSku";
import StoreNameCardTitle from "./components/StoreNameCardTitle";

const useStyles = makeStyles(
  theme => ({
    buttonOrange: {
      color: "#E26139 !important"
    },
    buttonPicked: {
      color: "#6DAB64 !important"
    },
    buttonPicking: {
      color: "#3D3D3D !important"
    },
    clickableRow: {
      cursor: "pointer"
    },
    colCheckBox: {
      paddingLeft: "12px !important"
    },
    colNameLabel: {
      marginLeft: "0px"
    },
    colPrice: {
      width: "20% !important"
    },
    colProductName: {
      paddingLeft: "0px"
      // width: "16em"
    },
    colQuantity: {
      width: "10% !important"
    },
    colSku: {
      width: "auto"
    },
    colStatus: {
      textAlign: "center",
      whiteSpace: "nowrap",
      width: "16em"
    },
    colStatusCell: {
      textAlign: "center",
      width: 120,
      [theme.breakpoints.down("sm")]: {
        fontSize: "11px",
        padding: "0px"
      }
    },
    colTotal: {
      width: "20% !important"
    },
    disabledSave: {
      color: "#a7a9ab !important"
    },
    infoLabel: {
      display: "inline-block"
    },
    infoLabelWithMargin: {
      marginBottom: theme.spacing()
    },
    infoRow: {
      padding: theme.spacing(2, 3)
    },
    orderCard: {
      marginBottom: "12px"
    },
    orderNumber: {
      display: "inline",
      marginLeft: theme.spacing(1)
    },
    orderTitle: {
      cursor: "pointer"
    },
    responsiveTable: {
      overflowX: "auto"
    },
    statusBar: {
      paddingTop: 0
    },
    table: {
      overflowX: "auto",
      width: "100%"
    },
    tableFooter: {
      color: "#3d3d3d",
      fontSize: "14px"
    },
    tableRow: {
      cursor: "pointer"
    },
    toolbarPick: {
      display: "inline-flex"
    }
  }),
  { name: "OrderDetailsList" }
);

const TableCellFooter = withStyles(
  {
    root: {
      borderBottom: "none"
    }
  },
  { name: "TableCellFooter" }
)(MuiTableCell);

// const DisplayColumn = TDisplayColumn as React.FunctionComponent<
//   DisplayColumnProps<OrderDetailsListColumns>
// >;

export interface OrderDetailsListProps
  extends ListProps<OrderDetailsListColumns> {
  order: OrderDetails_order_subOrders;
  subOrderLength: number;
  voucher: OrderDetails_order_voucher;
  deliveryType: DeliveryTypeEnum;
}

const OrderDetailsList: React.FC<OrderDetailsListProps> = props => {
  const { order, onRowClick, subOrderLength, voucher, deliveryType } = props;
  const classes = useStyles(props);
  const redirectStore = () => {
    window.open(storeOrderPath(order.id));
  };

  const decimalFormatter = new Intl.NumberFormat("en-PH", {
    currency: "PHP",
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    style: "currency"
  });

  return (
    <Card className={classes.orderCard}>
      <StoreNameCardTitle
        onClick={redirectStore}
        className={classes.orderTitle}
        orderName={order.orderCode}
        storeName={order.tenant.brand.name}
        toolbar={
          <div id="cmpOrderDetailsListOrderStatus">
            <OrderStatus status={maybe(() => order.smopStatus)} />
          </div>
        }
      />
      <div className={classes.responsiveTable}>
        <Table>
          {/* <div className={classes.responsiveTable}> */}
          <TableHead>
            <TableRow>
              <TableCellHeader
                id="tblHeaderOrderDetailsListProductName"
                className={classes.colProductName}
              >
                <FormattedMessage
                  id="txtHeaderOrderDetailsListProductName"
                  defaultMessage="Product"
                  description="product name"
                />
              </TableCellHeader>
              {/* <TableCellHeader className={classes.colSku}></TableCellHeader> */}
              <TableCellHeader
                id="tblHeaderOrderDetailsListQty"
                className={classes.colQuantity}
              >
                <FormattedMessage
                  id="txtHeaderOrderDetailsListQty"
                  defaultMessage="Qty"
                  description="ordered product quantity"
                />
              </TableCellHeader>
              <TableCellHeader className={classes.colPrice}>
                <FormattedMessage
                  id="txtHeaderOrderDetailsListPrice"
                  defaultMessage="Price"
                  description="ordered product price"
                />
              </TableCellHeader>
              <TableCellHeader
                id="tblHeaderOrderDetailsListTotal"
                className={classes.colTotal}
              >
                <FormattedMessage
                  id="txtHeaderOrderDetailsListTotal"
                  defaultMessage="Total"
                  description="ordered product total"
                />
              </TableCellHeader>
              {/* </DisplayColumn>
          <DisplayColumn column="status" displayColumns={settings.columns}> */}
              <TableCellHeader
                id="tblHeaderOrderDetailsListProductStatus"
                className={classes.colStatus}
              >
                <FormattedMessage
                  id="txtHeaderOrderDetailsListProductStatus"
                  defaultMessage="Status"
                  description="ordered product status"
                />
              </TableCellHeader>
              {/* </DisplayColumn> */}
            </TableRow>
          </TableHead>

          <TableBody>
            {renderCollection(
              order && order.lines,
              orderDetails => (
                <TableRow
                  id="btnTableRowHeaderOrderDetailsListProductModal"
                  hover={!!orderDetails}
                  className={classes.tableRow}
                  onClick={
                    orderDetails &&
                    orderDetails.id &&
                    onRowClick(
                      `{"variantId": "${orderDetails.id}", "storeOrderId": "${orderDetails.storeOrder.id}"}`
                    )
                  }
                  key={orderDetails ? orderDetails.id : "skeleton"}
                >
                  <TableCell
                    id={`tblCellOrderDetailsListProductName-${order?.orderCode}`}
                    className={classes.colProductName}
                    style={{ minWidth: "235px" }}
                  >
                    {maybe(() => orderDetails.productName) ? (
                      <div style={{ width: "auto" }}>
                        <span
                          id="txtOrderDetailsListProductName"
                          style={{ marginRight: "5px" }}
                        >
                          {orderDetails.productName}{" "}
                          {orderDetails.variantName !== "" ||
                          orderDetails.variantName !== undefined
                            ? `(${orderDetails.variantName})`
                            : ""}
                        </span>{" "}
                        <ProductSku
                          productSku={maybe(() => orderDetails.variant.sku)}
                        />
                      </div>
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  {/* <TableCell className={classes.colSku}>
                    <ProductSku
                      productSku={maybe(() => orderDetails.variant.sku)}
                    />
                  </TableCell> */}
                  <TableCell
                    id="tblCellOrderDetailsListQty"
                    className={classes.colQuantity}
                  >
                    {maybe(() => orderDetails.quantity) ? (
                      orderDetails.quantity + "x"
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    id="tblCellOrderDetailsListPrice"
                    className={classes.colPrice}
                  >
                    {maybe(() => orderDetails.unitPrice) ? (
                      <>
                        {decimalFormatter.format(
                          orderDetails.unitPrice.gross.amount
                        )}
                      </>
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    id="tblCellOrderDetailsListQtyTotalPrice"
                    className={classes.colTotal}
                  >
                    {maybe(() => orderDetails.totalPrice) ? (
                      <>
                        {decimalFormatter.format(
                          orderDetails.totalPrice.gross.amount
                        )}
                      </>
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    id="tblCellOrderDetailsListOrderLineStatus"
                    className={classes.colStatus}
                  >
                    <OrderLineStatus
                      status={order && order.lines ? orderDetails.status : ""}
                    />
                    {/* {maybe(() => storeOrder.order) ? (
                        orderDetails.quantity
                      ) : (
                        <Skeleton />
                      )} */}
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell
                    id="tblCellOrderDetailsListNoProductsFound"
                    colSpan={5}
                  >
                    <FormattedMessage
                      id="txtCellOrderDetailsListNoProductsFound"
                      defaultMessage="No products found"
                    />
                  </TableCell>
                </TableRow>
              )
            )}
            {isExpressDelivery(deliveryType) ||
            deliveryType === DeliveryTypeEnum.IN_STORE_PICKUP ? (
              <TableRow>
                <TableCell
                  id="tblCellOrderDetailsListPrepTimeLocation"
                  colSpan={5}
                >
                  <PrepTimeLocation order={order} />
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
          {/* </div> */}
          <TableFooter id="tblFooterOrderDetailsList">
            <TableRow>
              <TableCellFooter
                id="tblCellFooterOrderDetailsListSubTotal"
                colSpan={4}
              >
                <span className={classes.tableFooter}>
                  <b>
                    Sub-Total {`(1/${maybe(() => subOrderLength, 0)}) sellers`}
                  </b>
                </span>
              </TableCellFooter>
              <TableCellFooter
                id="tblCellFooterOrderDetailsListDecimalFormatter"
                style={{ textAlign: "right" }}
              >
                <span className={classes.tableFooter}>
                  {decimalFormatter.format(maybe(() => order.subtotal, 0))}
                </span>
              </TableCellFooter>
            </TableRow>
            <TableRow>
              <TableCellFooter
                id="tblCellFooterOrderDetailsListVoucherDiscount"
                colSpan={4}
              >
                <span className={classes.tableFooter}>
                  <b>Voucher Discount {maybe(() => `(${voucher.code})`, "")}</b>
                </span>
              </TableCellFooter>
              <TableCellFooter
                id="tblCellFooterOrderDetailsListDiscountAmount"
                style={{ textAlign: "right" }}
              >
                <span
                  id="txtCellFooterOrderDetailsListDiscountAmount"
                  className={classes.tableFooter}
                >
                  -
                  {decimalFormatter.format(
                    maybe(() => order.discountAmount, 0)
                  )}
                </span>
              </TableCellFooter>
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </Card>
  );
};
OrderDetailsList.displayName = "OrderDetails";
export default OrderDetailsList;
